
import ApiService from "./ApiService";
 
export async function apiDtcDashboardData(params) {
    return ApiService.fetchData({
        url: 'elastic/dtc-alerts/similar-search',
        method: 'get',
        params
    })
}
export async function apiDtcxlsxDashboardData(params) {
    return ApiService.fetchData({
        url: 'elastic/dtc-alerts/similar-search/download',
        method: 'get',
        params
    })
}
export async function apiSetSearchFilterList(params) {
    return ApiService.fetchData({
        url: 'operation/search-filter/user',
        method: 'get',
        params,
    })
}
export async function apiAutoRefreshTimeData(params) {
    return ApiService.fetchData({
        url: 'operation/system-param-config/autoRefresh',
        method: 'get',
        // params
    })
}

export async function apiDtcDashboardCount(params) {
    return ApiService.fetchData({
        url: 'elastic/dtc-alerts-count',
        method: 'get',
        params
    })
}

export async function apiGetAllRSAVehicleData(params) {
    return ApiService.fetchData({
        url: `operation/msvmr`,
        method: 'get',
        params,
    })
}

export async function apiCompleateDownload(params) {
    try {
        const response = await ApiService.fetchData({
            url: `elastic/dtc-alerts/download`,
            method: 'get',
            params,
        });

        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function createDtcDashboardData(data) {
    
    try {
        const resp = await ApiService.fetchData({
            url: 'operation/search-filter',
            method: 'post',
            data,
        })
        return {
            status: 'success',
            data: resp,
        }
    } catch (errors) {
        return {
            status: 'failed',
            message: errors?.response?.data || errors.toString(),
        }
    }
}

export async function updateApiSearchfilter(data, id) {
    try {
        const resp = await ApiService.fetchData({
            url: `operation/search-filter/${id}`,
            method: 'put',
            data,
        })
        return {
            status: 'success',
            data: resp,
        }
    } catch (errors) {
        return {
            status: 'failed',
            message: errors?.response?.data || errors.toString(),
        }
    }
}
 
export async function apiDropdownVarient(){
    return ApiService.fetchData({
        url:'operation/vehicle-catlogs/varient',
        method:'get'
    })
   
}
 
export async function apiDropdownBs(){
    return ApiService.fetchData({
        url:'operation/vehicle-catlogs/emission',
        method:'get'
    })
   
}
 
export async function apiCreateTicket(data) {
    try {
        const resp = await ApiService.fetchData({
            url: 'operation/ticketing-modules',
            method: 'post',
            data,
        })
        return {
            status: 'success',
            data: resp,
        }
    } catch (errors) {
        return {
            status: 'failed',
            message: errors?.response?.data || errors.toString(),
        }
    }
}
 
export async function apiGetVehicleDashboard(params) {
    return ApiService.fetchData({
        url: 'operation/vehicle-masters',
        method: 'get',
        params
    })
}
 
export async function apigetSamrtFileredData(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters-search/${params}`,
        method: 'get',
        // params
    })
}
 
export async function apiGetSearchList(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-meta-data/${params}`,
        method: 'get'
    })
}

export async function apiGetTicketStatus(params) {
    return ApiService.fetchData({
        url: `operation/ticketing-modules-comments-status/${params}`,
        method: 'get'
 
    })
}
 
export async function apiGetDealerLocaton(params) {
    try {
 
        const resp = await ApiService.fetchData({
            url: `operation/dealers-masters/location/${params}`,
            method: 'get',
        })
        return {
            status: 'success',
            data: resp,
        }
    } catch (errors) {
        return {
            status: 'failed',
            data: errors?.response?.data || errors.toString(),
        }
    }
}

export async function apiGetServiceDealerLocaton(params) {
    try {
 
        const resp = await ApiService.fetchData({
            url: `operation/dealers-masters/dealercodes`,
            method: 'get',
        })
        return {
            status: 'success',
            data: resp,
        }
    } catch (errors) {
        return {
            status: 'failed',
            data: errors?.response?.data || errors.toString(),
        }
    }
}

export async function deleteApiSearchfilter(id) {
    try {
        const resp = await ApiService.fetchData({
            url: `operation/search-filter/${id}`,
            method: 'delete',
        })
        return {
            status: 'success',
            data: resp,
        }
    } catch (errors) {
        return {
            status: 'failed',
            message: errors?.response?.data || errors.toString(),
        }
    }
}

export async function apiSetUserRoles(params) {
    return ApiService.fetchData({
        url: 'operation/file-upload/upload-by-list',
        method: 'get',
        params,
    })
}
export async function apiGetDTCfilters(params) {
    return ApiService.fetchData({
        url: `operation/dtc-masters/data-dropdown`,
        method: 'get',
        params
 
    })
}

export async function apiGetVehicleStatus(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/status-enum`,
        method: 'get',
        params
 
    })
}

export async function apiGetTicketingStatus(params) {
    return ApiService.fetchData({
        url: `elastic/dtc-alerts/tickets-status`,
        method: 'get',
        params
 
    })
}

export async function apiGetVehiclefilters(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/dropdown`,
        method: 'get',
        params
 
    })
}


export async function apiSearchbyALL(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/alerts-suggestion-search/${params}`,
        method: 'get',
        // params,
    })
}

export async function apiSearchbyVIN(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters-search-suggestions/${params}`,
        method: 'get',
        // params,
    })
}

export async function apiSearchbyRegn(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/regn-search/${params}`,
        method: 'get',
        // params,
    })
}
export async function apiSearchbyIMEI(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/imei-search/${params}`,
        method: 'get',
        // params,
    })
}

export async function apiSearchbyVarient(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/suggestions-by-varient/${params}`,
        method: 'get',
        // params,
    })
}

export async function apiSearchbyCustomerName(params) {
    return ApiService.fetchData({
        url: `operation/vehicle-masters/suggestions-by-custname/${params}`,
        method: 'get',
        // params,
    })
}

export async function apiGetTicketUsers(){
    return ApiService.fetchData({
        url:'account/acc-users/details',
        method:'get'
    })
   
}
export async function apiGetDTCTicketUsers(params){
    return ApiService.fetchData({
        url:'operation/shift-management/getExecutives/shift-info',
        method:'get',
        params,
    })
   
}

export async function apiSearchbyDTCCode(params) {
    return ApiService.fetchData({
        url: `operation/dtc-masters/dtc-code`,
        method: 'get',
        params,
    })
}

export async function apiSearchbyAgent(params) {
    return ApiService.fetchData({
        url: `account/acc-users/executive/suggestion-search`,
        method: 'get',
        params,
    })
}

export async function apigetAlertsTimeDifference(params) {
    return ApiService.fetchData({
        url: `operation/can-parameter/state-time-difference/${params}`,
        method: 'get',
        // params,
    })
}

export async function apigetLatestDTCStatus(data) {
    return ApiService.fetchData({
        url: `operation/dtc-alerts/latest-dtc-status?vin=${data?.vin}&imei=${data?.imei}&dtc_code=${data?.dtc_code}`,
        method: 'get',
       // params,
    })
}